import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

export const Container = styled(Flex)`
    width: 100%;
    height: 380px;
    border-radius: 6px;
    gap: 16px;
    flex: 1;
`;
